import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "toggle-menu",
  "use": "toggle-menu-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"toggle-menu\">\n<rect width=\"30\" height=\"30\" rx=\"15\" fill=\"#3A3A4F\" />\n<path d=\"M13.75 21.25L20 15L13.75 8.75\" stroke=\"white\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol